import { supabase } from './api'

const TABLE = 'studentsatscore'

export async function getStudentSatScores(studentId) {
	const { data, error } = await supabase
		.from(TABLE)
		.select()
		.eq('studentId', studentId)
		.order('satdate', { ascending: false, nullsFirst: false })
		.order('id', { ascending: false })

	if (error) {
		throw new Error(error.message || 'Failed to fetch SAT scores')
	}

	return data || []
}

export async function addStudentSatScore(row) {
	const payload = {
		studentId: row.studentId,
		satdate: row.satdate ?? null,
		enggrade: row.enggrade ?? null,
		mathgrade: row.mathgrade ?? null,
		enggoal: row.enggoal ?? null,
		mathgoal: row.mathgoal ?? null
	}

	const { data, error } = await supabase.from(TABLE).insert(payload).select()

	if (error) {
		throw new Error(error.message || 'Failed to add SAT score')
	}

	return data
}

export async function updateStudentSatScore(id, patch) {
	const allowed = ['studentId', 'satdate', 'enggrade', 'mathgrade', 'enggoal', 'mathgoal']
	const update = {}
	for (const key of allowed) {
		if (key in patch) {
			update[key] = patch[key]
		}
	}

	const { data, error } = await supabase.from(TABLE).update(update).eq('id', id).select()

	if (error) {
		throw new Error(error.message || 'Failed to update SAT score')
	}

	return data
}

export async function deleteStudentSatScore(id) {
	const { error } = await supabase.from(TABLE).delete().eq('id', id)

	if (error) {
		throw new Error(error.message || 'Failed to delete SAT score')
	}
}
